import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth';
import { getMe } from '../api/client';
import { usePageTitle } from '../hooks/usePageTitle';
import { useI18n } from '../i18n';
import AuthCard, { LogoIcon } from '../components/auth/AuthCard';
import AuthResult from '../components/auth/AuthResult';

/**
 * The end of a sign-in with a provider (#488). The API set the session
 * cookies before it redirected here, so the page reads the user and goes to
 * the home page. A refused sign-in never comes here: the API sends it to
 * /login?error=<CODE>.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const setAuth = useAuthStore(s => s.setAuth);
  const { t } = useI18n();
  usePageTitle(t.auth.signingIn);

  useEffect(() => {
    // StrictMode runs the effect twice in development: only the latest run acts.
    let live = true;
    getMe()
      .then(res => {
        if (!live) return;
        setAuth(res.data);
        navigate('/', { replace: true });
      })
      .catch(() => {
        if (live) navigate('/login?error=OAUTH_FAILED', { replace: true });
      });
    return () => { live = false; };
  }, []);

  return (
    <AuthCard>
      <AuthResult icon={LogoIcon} pulse text={t.auth.signingIn} />
    </AuthCard>
  );
}
